module.exports = __webpack_public_path__ + "img/three1Blue.adcbe1c7.jpg";